import { useEffect, useState } from 'react';

import { token as tokenService } from 'services/LocalStorage/localStorage';
import { network } from 'services/network';

import { useQueryState } from 'hooks/useQueryState';

import { useQueryGetUserDetail } from 'api/queries/getUserDetail.query';

import { useLoginHook } from 'components/App/AuthPublicPages/_hooks/loginHook';

export const ExternalLogin = () => {
    const [token] = useQueryState('token');
    const [emailFromQuery] = useQueryState('email');
    const [email, setEmail] = useState<string | undefined>(undefined);
    const { data: user } = useQueryGetUserDetail({
        email: email,
    });
    useEffect(() => {
        if (token && emailFromQuery) {
            tokenService.set(token);
            network.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            setEmail(emailFromQuery);
        }
    }, [token, emailFromQuery]);

    useLoginHook({ user, isSwitchUser: false });

    return null;
};
